import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, destroy } from 'redux-form';

import PositionField from 'shared/forms/PositionField';
import renderInputField from 'shared/forms/RenderInputField';

import Button from 'shared/components/Button';
import renderDropzoneInput from 'shared/components/DropzoneInput';
import PreferenceElement from 'shared/components/PreferenceElement';

import { getAvatarStyle } from 'pages/EditProfile/EditProfileForm/utils';
import { required, maxLength255 } from 'shared/forms/validators';

import { register, updateProfile } from 'shared/components/Signup/ducks';

import styles from './styles.module.scss';

const FORM_NAME = 'signupProfileForm';

class ProfileForm extends Component {
  componentWillUnmount() {
    this.props.destroy('registerForm');
  }

  submit(data) {
    if (_.isEmpty(this.props.user)) {
      const allData = {
        ...this.props.credentials,
        ...data
      };
      this.props.register(FORM_NAME, allData);
    } else {
      this.props.updateProfile(FORM_NAME, data);
    }
  }

  state = { avatar: { preview: null } };

  render() {
    const {
      handleSubmit,
      avatar,
      thumbnails,
      invalid,
      submitting
    } = this.props;

    const avatarPreview = this.state.avatar.preview;
    let dropzone = { ref: null };
    return (
      <form
        className={styles.wrapper}
        onSubmit={handleSubmit(this.submit.bind(this))}>
        <div className={styles.baseForm}>
          <div className={styles.inner}>
            <div className="secondary-title">Welcome to Unissu</div>
            <div className="page-title-label">
              To help us personalise your experience, please confirm your name
              and let us know how you wish to stay in contact with the Unissu
              community.
            </div>
            <div className={styles.avatarContainer}>
              <div
                className={styles.avatar}
                onClick={() => dropzone.ref.open()}
                style={getAvatarStyle(avatar, thumbnails, avatarPreview)}>
                <Field
                  name="profile.avatar"
                  className={styles.avatar}
                  multiple={false}
                  component={renderDropzoneInput(dropzone, 'image/*')}
                  onChange={(_, avatar) => {
                    this.setState({ avatar: avatar[0] });
                  }}
                />
              </div>
              <Button
                className={styles.uploadPhotoBtn}
                onClick={() => dropzone.ref.open()}
                type="button">
                Upload Photo
              </Button>
            </div>
            <div className={styles.row}>
              <div className="form-group">
                <label className="form-label">First name*</label>
                <Field
                  name="profile.first_name"
                  component={renderInputField}
                  type="input"
                  placeholder="Enter first name"
                  validate={[required, maxLength255]}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Surname*</label>
                <Field
                  name="profile.surname"
                  component={renderInputField}
                  placeholder="Enter surname"
                  validate={[required, maxLength255]}
                />
              </div>
            </div>
            <div className={styles.positionRow}>
              <div className="form-group">
                <PositionField required validate={required} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.questionsForm}>
          <div className={styles.inner}>
            <div className={styles.title}>
              We've got some fantastic emails to help you on your journey:
            </div>
            <PreferenceElement
              title="Unissu Updates"
              fieldName="user_preferences.industry_update"
              label="Opt in to receive the latest updates and opportunities as we release new features and tools to help you succeed in your job."
            />
            <PreferenceElement
              title="Unissu Messages"
              fieldName="user_preferences.unseen_messages_email"
              label="We’ll send you an email each time you get a message through Unissu’s in-platform messaging feature."
            />
            <PreferenceElement
              title="Marketing Emails"
              fieldName="user_preferences.marketing_emails"
              label="Occasionally we may have 3rd parties with propositions that may be of interest to you."
            />
            <Button
              className={styles.nextStepBtn}
              type="submit"
              color="primary"
              disabled={invalid || submitting}>
              Next step
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

ProfileForm = reduxForm({ form: FORM_NAME })(ProfileForm);

const mapStateToProps = state => {
  const user = state.me.user;

  const initialValues = {
    profile: {
      avatar: _.get(user, 'profile.avatar'),
      first_name: _.get(user, 'profile.first_name'),
      surname: _.get(user, 'profile.surname')
    },
    user_preferences: {
      industry_update: false,
      unseen_messages_email: false,
      marketing_emails: false
    }
  };

  return {
    credentials: _.get(state, 'form.registerForm.values'),
    avatar: _.get(user, 'profile.avatar'),
    thumbnails: _.get(user, 'profile.thumbnails'),
    user: user,
    initialValues: initialValues
  };
};

const mapDispatchToProps = {
  register,
  destroy,
  updateProfile
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileForm);
